// const namespace = 'validation';

const CONSUMER = {};

export default CONSUMER;
